import React from "react";
import { Box } from "@chakra-ui/react";

export const DesertBackground: React.FC = () => {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      overflow="hidden"
      zIndex="0"
      pointerEvents="none"
    >
      {/* Desert sky gradient */}
      <Box
        position="absolute"
        width="100%"
        height="100%"
        background="linear-gradient(180deg, #c4956a 0%, #d4a574 20%, #e8c49a 40%, #c9a06a 70%, #a67c52 100%)"
      />

      {/* Sun glow */}
      <Box
        position="absolute"
        top="8%"
        left="75%"
        width="120px"
        height="120px"
        borderRadius="50%"
        background="radial-gradient(circle, rgba(255,220,150,0.8) 0%, rgba(255,200,100,0.4) 40%, transparent 70%)"
        className="sun-glow"
      />

      {/* Desert landscape SVG - extra wide to hide edges during animation */}
      <svg
        className="desert-svg"
        viewBox="0 0 2880 800"
        preserveAspectRatio="none"
        style={{
          position: "absolute",
          bottom: 0,
          left: "-50%",
          width: "200%",
          height: "100%",
        }}
      >
        <defs>
          {/* Cliff gradients */}
          <linearGradient id="cliffGrad1" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#8b5a3c" stopOpacity="1" />
            <stop offset="50%" stopColor="#6b4530" stopOpacity="1" />
            <stop offset="100%" stopColor="#4a3020" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="cliffGrad2" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#9b6a4c" stopOpacity="0.95" />
            <stop offset="100%" stopColor="#5a4030" stopOpacity="1" />
          </linearGradient>

          {/* Dune gradients */}
          <linearGradient id="duneGrad1" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#d4a574" stopOpacity="1" />
            <stop offset="100%" stopColor="#b8956a" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="duneGrad2" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#c9986a" stopOpacity="1" />
            <stop offset="100%" stopColor="#a87c52" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="duneGrad3" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#b88a5a" stopOpacity="1" />
            <stop offset="100%" stopColor="#8a6040" stopOpacity="1" />
          </linearGradient>

          {/* Shadow for depth */}
          <linearGradient id="duneShadow" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#6a4a30" stopOpacity="0.4" />
            <stop offset="100%" stopColor="transparent" stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* Back cliffs - positioned in visible center area (720-2160) */}
        <g className="cliffs-back">
          <path
            fill="url(#cliffGrad1)"
            d="M720,400 L720,300 L800,280 L800,320 L870,300 L870,350 L920,320 L920,800 L720,800 Z"
          />
          <path
            fill="url(#cliffGrad1)"
            d="M1960,400 L1960,250 L2040,280 L2040,230 L2110,260 L2110,300 L2160,280 L2160,800 L1960,800 Z"
          />
        </g>

        {/* Middle cliffs with more detail */}
        <g className="cliffs-middle">
          <path
            fill="url(#cliffGrad2)"
            d="M820,500 L820,380 L900,350 L900,400 L970,370 L970,420 L1020,400 L1020,800 L820,800 Z"
          />
          <path
            fill="url(#cliffGrad2)"
            d="M1860,500 L1860,350 L1940,380 L1940,330 L2020,360 L2020,400 L2100,380 L2100,800 L1860,800 Z"
          />
        </g>

        {/* Back dunes - furthest, lightest */}
        <g className="dunes-back">
          <path
            fill="url(#duneGrad1)"
            d="M0,600 Q200,520 400,580 Q600,640 800,560 Q1000,480 1200,550 Q1400,620 1600,560 Q1800,500 2000,570 Q2200,630 2400,560 Q2600,500 2880,580 L2880,800 L0,800 Z"
          />
        </g>

        {/* Middle dunes */}
        <g className="dunes-middle">
          <path
            fill="url(#duneGrad2)"
            d="M0,680 Q150,600 350,660 Q550,720 700,640 Q900,560 1100,650 Q1300,720 1500,650 Q1700,580 1900,660 Q2100,730 2300,660 Q2500,590 2700,670 Q2800,700 2880,680 L2880,800 L0,800 Z"
          />
          {/* Dune shadow/ridge lines */}
          <path
            fill="url(#duneShadow)"
            d="M350,660 Q450,680 550,700 Q600,680 650,660 L650,665 Q600,685 550,705 Q450,685 350,665 Z"
            opacity="0.3"
          />
        </g>

        {/* Front dunes - closest, darkest */}
        <g className="dunes-front">
          <path
            fill="url(#duneGrad3)"
            d="M0,750 Q180,680 400,740 Q600,800 850,720 Q1050,640 1250,730 Q1450,800 1650,730 Q1850,660 2050,740 Q2250,810 2450,740 Q2650,670 2880,750 L2880,800 L0,800 Z"
          />
          {/* Ridge highlight */}
          <path
            fill="rgba(255,220,180,0.2)"
            d="M400,740 Q500,755 600,780 L600,782 Q500,757 400,742 Z"
          />
        </g>

        {/* Ground */}
        <rect x="0" y="780" width="2880" height="20" fill="#7a5a3a" />
      </svg>

      {/* Sand particles */}
      <Box className="sand-particles" position="absolute" width="100%" height="100%" top="0" left="0">
        {[...Array(20)].map((_, i) => (
          <Box
            key={i}
            className={`sand-particle sand-particle-${i + 1}`}
            position="absolute"
            width={i % 3 === 0 ? "3px" : "2px"}
            height={i % 3 === 0 ? "3px" : "2px"}
            borderRadius="50%"
            backgroundColor="#d4b896"
            opacity="0"
          />
        ))}
      </Box>

      {/* Heat shimmer overlay */}
      <Box
        className="heat-shimmer"
        position="absolute"
        bottom="0"
        left="0"
        width="100%"
        height="40%"
        background="linear-gradient(180deg, transparent 0%, rgba(255,240,220,0.1) 100%)"
        pointerEvents="none"
      />
    </Box>
  );
};

export default DesertBackground;
